var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#479951"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.044 218.768C360.096 269.533 320.211 311.598 267.592 317.488L266.473 317.6C207.538 323.588 154.755 281.972 146.308 223.914C145.619 231.048 145.593 238.366 146.345 245.769C152.497 306.319 206.594 350.418 267.144 344.266L268.263 344.154C328.31 337.433 371.748 283.58 365.641 223.467C365.479 221.878 365.271 220.333 365.044 218.768H365.044Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.482 167.161L262.371 201.544L298.133 199.944L268.798 220.924L281.37 254.441L252.352 233.025L224.36 255.34L235.761 221.123L205.888 201.398L241.953 201.667L251.482 167.161Z",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/MR.7803b5036466b0fa7da79d7796e29324.svg";
export { ForwardRef as ReactComponent };